module.exports = __webpack_public_path__ + "img/img7.ea8db39b.jpg";